module.exports = __webpack_public_path__ + "img/MG.88795f6f.svg";